// Third-party libraries
import 'reflect-metadata';

// App API
import {API_METADATA} from '../metadata/api.metadata';

export function SkipWorkspaceHeader(): MethodDecorator {
  return (target: object, propertyKey: string | symbol, descriptor: PropertyDescriptor) => {
    Reflect.defineMetadata(API_METADATA.SKIP_WORKSPACE_HEADER, true, target, propertyKey);
    return descriptor;
  };
}
